export const PLATFORMS = {
  VIRTUAL_PRO: 'virtualpro',
  HUBILO: 'hubilo',
  WEBINAR_PLUS: 'webinarplus',
};

export const PLATFORM_DOMAINS = {
  [PLATFORMS.VIRTUAL_PRO]: process.env.REACT_APP_VPRO_DOMAIN || 'admin.virtualpro.com',
  [PLATFORMS.HUBILO]: process.env.REACT_APP_HUBILO_DOMAIN || 'dash.hubilo.com',
  [PLATFORMS.WEBINAR_PLUS]: process.env.REACT_APP_WPLUS_DOMAIN || 'admin.webinarplus.com',
};

export const PLATFORM_NAMES = {
  [PLATFORMS.VIRTUAL_PRO]: 'Virtual Pro',
  [PLATFORMS.HUBILO]: 'Virtual Pro',
  [PLATFORMS.WEBINAR_PLUS]: 'Webinar+',
};

export const SITE_BUILDER_NAMES = {
  [PLATFORMS.VIRTUAL_PRO]: 'Media+',
  [PLATFORMS.HUBILO]: 'Media+',
  [PLATFORMS.WEBINAR_PLUS]: 'Hubs',
};

export const PLATFORM_META = {
  [PLATFORMS.VIRTUAL_PRO]: {
    title: 'Virtual Pro - Event Dashboard',
    themeColor: '#D93E33',
    favicon: `${process.env.PUBLIC_URL}/favicon.svg`,
    faviconType: 'image/svg+xml',
    manifestUrl: `${process.env.PUBLIC_URL}/manifest.json`,
    primaryBase: '#E97CC2',
    typoFontFamily: 'Libre Franklin',
    headerFontFamily: 'Arvo',
  },
  [PLATFORMS.WEBINAR_PLUS]: {
    title: 'Webinar+',
    themeColor: '#FF4E3C',
    favicon: `${process.env.PUBLIC_URL}/favicon-wplus.png`,
    faviconType: 'image/png',
    manifestUrl: `${process.env.PUBLIC_URL}/manifest-wplus.json`,
    primaryBase: '#FF4E3C',
    typoFontFamily: 'TASA Orbiter',
    headerFontFamily: 'TASA Orbiter',
    backgroundDefault: '#ffffff',
  },
  [PLATFORMS.HUBILO]: {
    title: 'Virtual Pro - Event Dashboard',
    themeColor: '#D93E33',
    favicon: `${process.env.PUBLIC_URL}/favicon.svg`,
    faviconType: 'image/svg+xml',
    manifestUrl: `${process.env.PUBLIC_URL}/manifest.json`,
    primaryBase: '#E97CC2',
    typoFontFamily: 'Libre Franklin',
    headerFontFamily: 'Arvo',
  },
};

export const EVENT_TERMS = {
  [PLATFORMS.VIRTUAL_PRO]: { singular: 'Event', plural: 'Events', section: 'Events' },
  [PLATFORMS.WEBINAR_PLUS]: { singular: 'Webinar', plural: 'Webinars', section: 'Projects' },
  [PLATFORMS.HUBILO]: { singular: 'Event', plural: 'Events', section: 'Events' },
};

export function detectPlatform() {
  const { hostname } = window.location;

  let resolvedPlatform = null;

  if (hostname.includes('virtualpro')) {
    resolvedPlatform = PLATFORMS.VIRTUAL_PRO;
  } else if (hostname.includes('webinarplus')) {
    resolvedPlatform = PLATFORMS.WEBINAR_PLUS;
  } else if (
    hostname.includes('hubilo') ||
    hostname.includes('demohubilo')
  ) {
    resolvedPlatform = PLATFORMS.HUBILO;
  } else {
    resolvedPlatform = PLATFORMS.VIRTUAL_PRO;
  }
  return resolvedPlatform;
}

export const CURRENT_PLATFORM = detectPlatform();
export const CURRENT_PLATFORM_NAME = PLATFORM_NAMES[CURRENT_PLATFORM] ?? PLATFORM_NAMES[PLATFORMS.WEBINAR_PLUS];
export const CURRENT_SITE_BUILDER_NAME = SITE_BUILDER_NAMES[CURRENT_PLATFORM] ?? SITE_BUILDER_NAMES[PLATFORMS.VIRTUAL_PRO];
export const CURRENT_EVENT_TERMS = EVENT_TERMS[CURRENT_PLATFORM] ?? EVENT_TERMS[PLATFORMS.VIRTUAL_PRO];
export const PLATFORM_WEBSITE_URL =
  CURRENT_PLATFORM === PLATFORMS.WEBINAR_PLUS ? 'https://webinarplus.com' : 'https://virtualpro.com';

const MEDIA_PLUS_PROD_DOMAINS = {
  [PLATFORMS.WEBINAR_PLUS]: 'https://hubs.webinarplus.com',
  [PLATFORMS.VIRTUAL_PRO]: 'https://mediaplus.virtualpro.com',
  [PLATFORMS.HUBILO]: 'https://mediaplus.virtualpro.com',
};


const getNonProdMediaPlusDomain = (environment) => {
  return {
    [PLATFORMS.WEBINAR_PLUS]: `https://hubs.webinarplus-${environment}.com`,
    [PLATFORMS.VIRTUAL_PRO]: `https://mediaplus.virtualpro-${environment}.com`,
    [PLATFORMS.HUBILO]: `https://mediaplus.virtualpro-${environment}.com`,
  }
}

export function getMediaPlusUrl(platform = CURRENT_PLATFORM) {
  const isProd = process.env.REACT_APP_ENV_TYPE === 'prod';
  const vproEnv = process.env.REACT_APP_VIRTUAL_PRO_ENV_TYPE;
  const domains = isProd ? MEDIA_PLUS_PROD_DOMAINS : getNonProdMediaPlusDomain(vproEnv);
  return domains[platform] ?? domains[PLATFORMS.VIRTUAL_PRO];
}

export function getPlatformSupportMail(platform = CURRENT_PLATFORM) {
  const supportMails = {
    [PLATFORMS.WEBINAR_PLUS]: 'support-webinarplus@brandlive.com',
    [PLATFORMS.VIRTUAL_PRO]: 'support-vpro@brandlive.com',
  }
  return supportMails[platform] ?? supportMails[PLATFORMS.VIRTUAL_PRO];
}